import api from '../../services/serviceBase'

export default {
    // Moves the DEMO.TRACKMYDAY.ORG practice's 120-day history forward so it
    // ends today. Takes no arguments - the stored procedure hard-codes the
    // practice, so there is nothing for the caller to supply.
    
   
    refreshDemoData() {
  
        return api.execute('post', '/RefreshDemoData/RefreshDemoData')
    }
}
